import { useGetProductScenarios } from "@/pages/products/useProducts";
import { Button } from "antd";
import styles from "../ProductScenarios.module.scss";
import AddScenarioAction from "./AddScenarioAction";
import ProductScenario from "./ProductScenario";
import ProductScenarioSkeleton from "./ProductScenarioSkeleton";

export default function ManageProductScenarios({ productId }: { productId: number }) {
  const productScenarios = useGetProductScenarios({
    productId,
  });

  const compareImpact = productScenarios.data?.scenarios.find((x) => x.id === 0)?.impact;

  return (
    <>
      {productScenarios.isLoading ? (
        <>
          <ProductScenarioSkeleton title={"Current BOM"} />
          <ProductScenarioSkeleton />
        </>
      ) : (
        productScenarios.data?.scenarios.map((scenario) =>
          scenario.isStale ? (
            <ProductScenarioSkeleton
              key={scenario.id}
              title={scenario.name}
            />
          ) : (
            <ProductScenario
              key={scenario.id}
              productId={productId}
              scenario={scenario}
              compareImpact={scenario.id !== 0 ? compareImpact : undefined}
            />
          )
        )
      )}
      <div className={styles.add}>
        <AddScenarioAction productId={productId}>
          <Button type="primary">Add scenario</Button>
        </AddScenarioAction>
      </div>
    </>
  );
}
